var render, staticRenderFns
import script from "./RealBarChart.vue?vue&type=script&lang=js&"
export * from "./RealBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b32e5e",
  null
  
)

export default component.exports